module.exports = "/parking-permit/fonts/vendor/@mdi/materialdesignicons-webfont.woff2?d0066537ab6a4c6f8285a5aeb3ba5f09";